import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';

/**
 * Table cell for text value.
 */
export function TableCellText({ data }: { data: string }) {
  return (
    <Typography title={data} component="div" variant="body2">
      {data}
    </Typography>
  );
}
